import { createAction, handleActions } from 'redux-actions'

const setSearch = createAction('SCREENS/SUBBIES/SUB_ORDERS/SET_SEARCH')
const resetSearch = createAction('SCREENS/SUBBIES/SUB_ORDERS/RESET_SEARCH')

const defaultState = ''

const reducer = handleActions(
  {
    [setSearch]: (state, { payload }) => payload,
    [resetSearch]: () => defaultState,
  },
  defaultState,
)

export { setSearch, resetSearch, reducer }
